import { regex } from './validation';

/**
 * Formats the given phone number to add spaces and symbols
 * @param value number to be formatted
 * @returns Formatted phone number
 */
export const formatPhoneNumber = (value: string | undefined): string => {
    if (!value) return '';
    let phoneNumber = value.replace(regex.onlyNumbers, '');
    const phoneNumberLength = phoneNumber.length;
    if (phoneNumberLength < 4) return phoneNumber;
    if (phoneNumberLength < 7) {
        return `${phoneNumber.slice(0, 3)}-${phoneNumber.slice(3)}`;
    }

    phoneNumber = phoneNumber.replace(/^\+?1(\d{10}\d*)$/, '$1');
    return `${phoneNumber.slice(0, 3)}-${phoneNumber.slice(3, 6)}-${phoneNumber.slice(6)}`;
};
